module.exports = "/assets/data/fd72d50ba5af16cbc7adbbff54276c9e-WC1A.data.json";